import type { SVGProps } from 'react';
import { SPRITE_SYMBOL_IDS } from '@/app/elements/svg/sprite/sprite-symbol-ids';

export const InfoIconSymbol = () => (
    <symbol id={SPRITE_SYMBOL_IDS.INFO} viewBox="0 0 15 15" fill="none" data-testid="info-icon-symbol">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.5C0 3.35824 3.35824 0 7.5 0C11.6418 0 15 3.35824 15 7.5C15 11.6418 11.6418 15 7.5 15C3.35824 15 0 11.6418 0 7.5ZM0.882377 7.5C0.882377 11.1485 3.85149 14.1176 7.50002 14.1176C11.1486 14.1176 14.1177 11.1485 14.1177 7.5C14.1177 3.85147 11.1486 0.88235 7.50002 0.88235C3.85149 0.88235 0.882377 3.85147 0.882377 7.5ZM7.50003 5.29412C7.2565 5.29412 7.05885 5.49177 7.05885 5.7353V11.9118C7.05885 12.1553 7.2565 12.3529 7.50003 12.3529C7.74356 12.3529 7.9412 12.1553 7.9412 11.9118V5.7353C7.9412 5.49177 7.74356 5.29412 7.50003 5.29412ZM7.05885 3.08823C7.05885 2.8447 7.2565 2.64705 7.50003 2.64705C7.74356 2.64705 7.9412 2.8447 7.9412 3.08823V3.97058C7.9412 4.21411 7.74356 4.41176 7.50003 4.41176C7.2565 4.41176 7.05885 4.21411 7.05885 3.97058V3.08823Z"
            fill="white"
        />
    </symbol>
);

const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <use href={`#${SPRITE_SYMBOL_IDS.INFO}`} />
    </svg>
);

export default InfoIcon;
